<script lang="ts">
    
    import type { Color } from "../../global";

    export let disabled = false;
    export let color: Color = 'primary';

</script>

<button type="button" {disabled} on:click class={color}>
    <slot />
</button>

<style lang="scss">

    button {
        padding: 0.5rem 1rem;
        border: none;
        color: #fff;
        outline: none;
        font-size: 1.2rem;
        border-radius: 5px;
        height: 38px;

        &.primary {
            background-color: var(--color-primary);
        }

        &.secondary {
            background-color: var(--color-secondary);
        }

        &.aux {
            background-color: var(--color-aux);
        }

        &:disabled {
            background-color: #666;
        }
    }

</style>
